import type { _ActionsTree } from "pinia";
import type { ProfileStoreState } from "~/store/profile/state";

export interface ProfileStoreActions extends _ActionsTree {
}

export const actions: ProfileStoreActions | ProfileStoreState = {
};
